import { AssetTypes } from 'sigma-mappings';

// Ids de Tipo de Ativo, constantes na API.
export const assetsTypesIds = {
  [AssetTypes.TRANSFORMER]: 'E197BBC3-4AE5-4D95-832B-B980555CEF6F',
  [AssetTypes.DISCONNECTOR]: '5FE7F119-F7C5-4921-AA99-2E0FB85710DC',
  [AssetTypes.CIRCUIT_BREAKER]: '1887EC53-04D1-4907-9C30-EA6D756AB418',
};

export default {
  assetsTypesIds,
};
